import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Chip,
  Typography,
  Card,
  InputLabel,
  Grid,
  CardContent,
  Button,
  TextField,
  Alert, 
  AlertTitle,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  Input,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { getSalesOffices, GetSyConfiguration, GetSyPlanConfiguration,GetRouteConfiguration } from "../../utils/GetAdmin";
import requestMissingContexts, { determineConfig, determineConfigLong} from "../../utils/GetContext";
import {checkForRole} from "../../utils/GetAuth";
import {saveSyConfiguration, saveSyPlanConfiguration,saveSyRouteConfiguration} from "../../utils/PostAdmin";
import {
  Lock,
  Save,
 } from '@mui/icons-material';
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'

 interface HeaderState {
  isLoaded: boolean,
  allSalesOffices: any,
  allRoutes: any,
  allSubTradeChannels: any,
  filteredRoutes: string[],
  salesOffices: string[],
  routes: string[],
  subtradeChannels: string[],
}

interface syPlanModeConfig{
  client_id?: number;
  sales_org?: string;    
  delivering_plant: string;
  plan_mode : string;
  is_default : boolean;
  guid?: string;
}

const useStyles = makeStyles((theme: Theme) => 
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    chipActual: {
      marginTop: theme.spacing(2),
      marginRight: theme.spacing(1),
      marginBottom: theme.spacing(2)
    },   
    root: {},
    divWidth: {
      width: "100%",
    },
    card: {
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    input: {
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
      chip: {
          margin: 2,
        },
  })
);

export default function AdminMaterialStrategic(settings:{vp?:boolean,vs?:boolean}) {
  const classes = useStyles();
  const [syConfiguration, setSyConfiguration] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [curSettings, setCurSettings] = React.useState<any>();
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [refresh, setRefresh] = React.useState<boolean>(false);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [isChecked, setIsChecked] = React.useState<boolean>(false);
  const [deliveringPlants, setDeliveringPlants] = useState<any>();
  const [selectedDeliveringPlant, setSelectedDeliveringPlant] = useState<any[]>([]);
  const [syPlanModeConfiguration, setSyPlanModeConfiguration] = useState<syPlanModeConfig[]>([]);
  const [defaultPlanMode, setDefaultPlanMode] = useState<any[]>([]);
  const [selectedPlanMode, setSelectedPlanMode] = useState<string>('');
  const [planModeLoader, setPlanModeLoader] = useState<boolean>(false);
  const [isRouteChecked, setIsRouteChecked] = React.useState<boolean>(false);
  const [isRouteReset, setIsRouteReset] = React.useState<boolean>(false);
  const [status, setStatus] = useState(false);
  const [statusMessage, setStatusmessage] = useState('');

  let param_name ='RESET ROUTE';
  const enabled = (
                    (!settings.vs || checkForRole(clientId,salesOrg,'vs_admin'))
                    && (!settings.vp || checkForRole(clientId,salesOrg,'vp_admin'))
                  );

  const handleValidationsOnSave = (message: string)=>{
    setStatusmessage(`${message}`);
    setStatus(true);
  }                  

  const handleSave = (event: any, index: number, cofnNumSetMaxIndex: any = undefined) => {
    let sConf: any = [];
    if (cofnNumSetMaxIndex!== undefined) {
      const objCONFMax = syConfiguration[cofnNumSetMaxIndex];
      const objCONFMin = syConfiguration[index];
      if(objCONFMin.param_value === '' || objCONFMax.param_value === ''){
        handleValidationsOnSave(`${objCONFMin.param_name} Or ${objCONFMax.param_name} can not be blank, And ${objCONFMin.param_name} should not be greater then ${objCONFMax.param_name}`)
        return;
      }
      if(parseInt(objCONFMin.param_value) > parseInt(objCONFMax.param_value)){
        handleValidationsOnSave(`Parameter ${objCONFMin.param_name} can not be greater than the ${objCONFMax.param_name}`);
        return;
      }
      sConf.push(syConfiguration[cofnNumSetMaxIndex]);
    }
    const objSystemConfig = syConfiguration[index];
    if(objSystemConfig.param_value === ''){
      handleValidationsOnSave(`Parameter ${objSystemConfig.param_name} can not be blank.`);
      return;
    }
    sConf.push(syConfiguration[index]);
    saveSyConfiguration(salesOrg, settings, sConf).then((v) => {
      if (v && v.syConfiguration) {
        setSyConfiguration(v.syConfiguration);
      } else if (v && v.message) {
        let syConfig = syConfiguration;
        syConfig[index].changed = false;
        setSyConfiguration(syConfig);
        setRefresh(true);
      }
    });
  };



  const savePlanMode = ()=> {

    let planModeConfig: any[] = []

    if(selectedPlanMode.length > 0) {
      planModeConfig.push({
        client_id: 100,
        delivering_plant: '',
        is_default: true,
        plan_mode: selectedPlanMode,
        sales_org: salesOrg,
       })
    }

    if(isChecked === true) {
    let defaultConfig = syPlanModeConfiguration?.reduce((result: any, currentValue: any) => {

      result[currentValue?.delivering_plant] = result[currentValue?.delivering_plant] || {}

      result[currentValue?.delivering_plant] = currentValue

      return result;

    }, {});

  selectedDeliveringPlant?.map((item:any) => {
      if(defaultConfig[item]) {
        planModeConfig.push({
       ...defaultConfig[item],
       plan_mode: selectedPlanMode === 'STATIC' ? 'DYNAMIC' : 'STATIC'
         })
      } else {
        planModeConfig.push({
          client_id: 100,
          delivering_plant: item,
          is_default: false,
          plan_mode: selectedPlanMode === 'STATIC' ? 'DYNAMIC' : 'STATIC',
          sales_org: salesOrg,
         })
      }
    })
  }
  setPlanModeLoader(true);
    saveSyPlanConfiguration(salesOrg,planModeConfig).then(v => {
     setPlanModeLoader(false);
      if(v && v.syPlanModeConfig) {
        planModeManipulations(v);
      }
    });
  };

 const handleDeliveryPlantChange = (event:any) => {
        setSelectedDeliveringPlant(event.target.value);

  }

  const planModeManipulations = (v:any) => {
    setSyPlanModeConfiguration(v?.syPlanModeConfig);
    
    // Separating all delivering plants as a list        
          let deliveringPlantsList:any = []
             v?.syPlanModeConfig.forEach((x:any) => {
                if(!x.is_default) {
                  deliveringPlantsList.push(x.delivering_plant);
                }
              });
      
              setSelectedDeliveringPlant(deliveringPlantsList);
              const defaultItem = v?.syPlanModeConfig.filter((v:any) => v.is_default);
              setSelectedPlanMode(defaultItem[0]?.plan_mode ? defaultItem[0]?.plan_mode : '' )
              setDefaultPlanMode(defaultItem)
      
              setIsChecked(deliveringPlantsList?.length > 0 ? true : false);
  }

  const inputFieldsValidations = (input: any)=>{
    let regExp = new RegExp("^\\d+$");
    let isValid = regExp.test(input);
    return (input.length > 2 || !isValid && input !== '')
  }

  useEffect(() => {
    getSalesOffices(salesOrg).then((v) => {
      setDeliveringPlants(v);
      setDoneLoading(true);
    });
  }, []);


  useEffect(() => {
    if(defaultPlanMode[0]?.plan_mode === selectedPlanMode || selectedPlanMode?.length === 0) {
      GetSyPlanConfiguration(salesOrg).then((v) => {
        planModeManipulations(v);
      });
    }
    GetRouteConfiguration(salesOrg,param_name).then((v) => {
      let paramval= (v.result[0].param_value=='1')?true:false;
      setIsRouteChecked(paramval);
    });

  }, [selectedPlanMode]);




  useEffect(() => {
    if (doneLoading && curSettings === settings && !refresh) return;
    if ((!doneLoading || curSettings !== settings) && !refresh){
      let newCodes:any
      let syConfig:any
      Promise.all(
        [
          (
            requestMissingContexts(["sy_config"])
              .then((v) => {
                newCodes = v;
              })
          ),
          (
            GetSyConfiguration(salesOrg,settings).then((v) => {
              if(v && v.syConfiguration) syConfig = v.syConfiguration
            })
          ),
        ]
      )
      .then(()=>{
        setCodes(newCodes);
        setSyConfiguration(syConfig);
        setDoneLoading(true);
        setCurSettings(settings);
      })
      .catch(()=>setDoneLoading(true))
    }
    setRefresh(false)
  }, [syConfiguration, settings, refresh, doneLoading, curSettings, salesOrg]);
  
  const saveRouteReset = ()=> {
    setPlanModeLoader(true);
      let client_id= 100
      //let param_name ='RESET ROUTE'
      let param_value= isRouteChecked
      let sales_org = salesOrg
      saveSyRouteConfiguration(sales_org,client_id,param_name,param_value).then(v => {
        setIsRouteReset(false);
        setPlanModeLoader(false);
      /* if(v && v.syPlanModeConfig) {
         planModeManipulations(v);
       }*/
     });
  }

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.paragraph}>
        System Configuration
      </Typography>
      {doneLoading && enabled && syConfiguration ? (
        <Grid container spacing={2} className={classes.primary}>
          {syConfiguration.map((sCnf, scIndx) =>
            sCnf.param_name !== "CONF_NUM_SET_MAX" ? (
              <Grid item xs={12} md={12} xl={12}>
                <Card className={classes.card}>
                  <CardContent>
                    <Typography variant="h4" className={classes.paragraphAct} paragraph>
                      {`${determineConfig(codes, "sy_config", sCnf.param_name) || sCnf.param_name}`}
                    </Typography>
                    {sCnf.vp && sCnf.vs ? (
                      <Chip label="VendPrime AND VendSmart" className={classes.chipActual} color="primary" />
                    ) : (
                      <div></div>
                    )}
                    <Typography
                      variant="subtitle1"
                      className={classes.paragraphAct}
                      paragraph
                      dangerouslySetInnerHTML={{ __html: determineConfigLong(codes, "sy_config", sCnf.param_name) }}
                    ></Typography>

                    <Grid container item xs={"auto"} md={"auto"} xl={"auto"} spacing={24}>
                      {(sCnf.param_name === "PRIORITY ENABLE" ||  sCnf.param_name === "REVIEW_ENABLE" ||  sCnf.param_name === "SORT_ROUTE_CARD")? (
                        <>
                        <Grid item xs={4}>
                          <FormGroup>
                            <FormControlLabel
                              sx={{ justifyContent: "start" }}
                              control={
                                <Checkbox
                                  checked={Number(sCnf.param_value) === 1 ? true : false}
                                  onChange={(ce) => {
                                    let syConfig = syConfiguration;
                                    syConfig[scIndx].param_value = ce.target.checked === true ? "1" : "0";
                                    syConfig[scIndx].changed = true;
                                    setSyConfiguration(syConfig);
                                    setRefresh(true);
                                  }}
                                  inputProps={{ "aria-label": "controlled" }}
                                />
                              }
                              label= {sCnf.param_name === "PRIORITY ENABLE" ? "Enable Prioirty Scheduler" : (sCnf.param_name === "SORT_ROUTE_CARD")? " Sort Route Card By Column": "Enable Review Feature"} 
                              labelPlacement="start"
                            />
                          </FormGroup></Grid>
                        </>
                      ) : (
                        <>
                          <Grid item xs={4}>
                            <InputLabel>{sCnf.param_name}</InputLabel>
                            <TextField
                              placeholder="Value"
                              type="text"
                              className={classes.input}
                              value={sCnf.param_value}
                              onChange={(ce) => {
                                if(sCnf.param_name !== 'VISIT_PLAN_MODE' && inputFieldsValidations( ce.target.value)){
                                  ce.preventDefault()
                                  return;
                                }
                                let syConfig = syConfiguration;
                                syConfig[scIndx].param_value = ce.target.value;
                                syConfig[scIndx].changed = true;
                                setSyConfiguration(syConfig);
                                setRefresh(true);
                              }}
                            ></TextField>
                          </Grid>
                          {syConfiguration.find((ele) => ele.param_name === "CONF_NUM_SET_MAX") !== undefined &&
                          sCnf.param_name === "CONF_NUM_SET_MIN" ? (
                            <>
                              <Grid item xs={4}>
                                <InputLabel>
                                  {syConfiguration.find((ele) => ele.param_name === "CONF_NUM_SET_MAX")?.param_name}
                                </InputLabel>
                                <TextField
                                  placeholder="Value"
                                  type="text"
                                  className={classes.input}
                                  value={
                                    syConfiguration.find((ele) => ele.param_name === "CONF_NUM_SET_MAX")?.param_value
                                  }
                                  onChange={(ce) => {
                                    if(inputFieldsValidations( ce.target.value)){
                                      ce.preventDefault()
                                      return;
                                    }
                                    let syConfig = syConfiguration;
                                    let cofnNumSetMaxIndex = syConfig.findIndex(
                                      (ele) => ele.param_name === "CONF_NUM_SET_MAX"
                                    );
                                    syConfig[cofnNumSetMaxIndex].param_value = ce.target.value;
                                    syConfig[scIndx].changed = true;
                                    setSyConfiguration(syConfig);
                                    setRefresh(true);
                                  }}
                                ></TextField>
                              </Grid>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </Grid>
                    <div style={{ paddingRight: "5px", textAlign: "right" }}>
                      <Button
                        color="primary"
                        variant="contained"
                        disabled={!sCnf.changed}
                        onClick={(ce) => {
                          let cofnNumSetMaxIndex;
                          if (
                            syConfiguration.find((ele) => ele.param_name === "CONF_NUM_SET_MAX") !== undefined &&
                            sCnf.param_name === "CONF_NUM_SET_MIN"
                          ) {
                            cofnNumSetMaxIndex = syConfiguration.findIndex(
                              (ele) => ele.param_name === "CONF_NUM_SET_MAX"
                            );
                          }
                          handleSave(ce, scIndx, cofnNumSetMaxIndex);
                        }}
                      >
                        <Save /> Save
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              <></>
            )
          )}
          {settings?.vs && (
            <>
              <Grid item xs={12} md={12} xl={12}>
                <>
                  {planModeLoader && (
                    <div className={classes.centerDiv}>
                      <CircularProgress color="primary" />
                    </div>
                  )}
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography variant="h4" className={classes.paragraphAct} paragraph>
                        PLAN_MODE
                      </Typography>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <InputLabel>Default PLAN_MODE</InputLabel>

                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                          <InputLabel>Select default plan mode</InputLabel>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-simple-select-standard"
                            className={classes.input}
                            value={selectedPlanMode}
                            onChange={(e) => {
                              setSelectedPlanMode(e.target.value);
                              defaultPlanMode[0]?.plan_mode !== e.target.value && setSelectedDeliveringPlant([]);
                              defaultPlanMode[0]?.plan_mode !== e.target.value && setIsChecked(false);
                            }}
                            label="Default Plan Mode"
                          >
                            <MenuItem value={"STATIC"}>STATIC</MenuItem>
                            <MenuItem value={"DYNAMIC"}>DYNAMIC</MenuItem>
                          </Select>
                        </FormControl>
                        <div style={{ marginTop: "15px" }}>
                          <TextField
                            placeholder="Plan Mode"
                            type="text"
                            className={classes.input}
                            value={
                              selectedPlanMode?.length === 0 ? "" : selectedPlanMode === "STATIC" ? "DYNAMIC" : "STATIC"
                            }
                            inputProps={{ readOnly: true }}
                          ></TextField>
                          <Checkbox
                            checked={isChecked}
                            size="small"
                            // style={{padding:"0px", marginLeft:"-25px"}}
                            onChange={() => {
                              setIsChecked(!isChecked);
                            }}
                          />
                        </div>
                        {isChecked && (
                          <FormControl className={classes.input} fullWidth>
                            <InputLabel id="select-multiple-so-label">Delivery Plant</InputLabel>
                            <Select
                              multiple
                              className={classes.input}
                              value={selectedDeliveringPlant}
                              onChange={handleDeliveryPlantChange}
                              input={<Input id="select-multiple-so" />}
                              renderValue={(selected: any) => (
                                <div className={classes.chips}>
                                  {selected.map((value: any) => (
                                    <Chip key={value} label={value} className={classes.chip} />
                                  ))}
                                </div>
                              )}
                            >
                              {deliveringPlants ? (
                                Object.entries(deliveringPlants).map((so: any, i: number) => (
                                  <MenuItem key={so[1].code} value={so[1].code}>
                                    <Checkbox checked={selectedDeliveringPlant.indexOf(so[1].code) > -1} />
                                    {so[1].code + " - " + so[1].text}
                                  </MenuItem>
                                ))
                              ) : (
                                <div></div>
                              )}
                            </Select>
                          </FormControl>
                        )}
                      </Grid>
                      <div style={{ paddingRight: "5px", textAlign: "right" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          // disabled={!isChecked}
                          onClick={() => {
                            savePlanMode();
                          }}
                        >
                          <Save /> Save
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </>
              </Grid>

              <Grid item xs={12} md={12} xl={12}>
                <>
                  <Card className={classes.card}>
                    <CardContent>
                      <Typography variant="h4" className={classes.paragraphAct} paragraph>
                        Warn on Route Reset
                      </Typography>
                      <Typography variant="subtitle1" className={classes.paragraphAct} paragraph>
                        Alerts the planner when they unplan a customer that originates from another master route by
                        informing them the customer was moved back to its master route
                      </Typography>
                      <Grid item xs={"auto"} md={"auto"} xl={"auto"}>
                        <FormGroup>
                          <FormControlLabel
                            sx={{ justifyContent: "start" }}
                            control={
                              <Checkbox
                                checked={isRouteChecked}
                                size="small"
                                inputProps={{ "aria-label": "controlled" }}
                              />
                            }
                            label="Enable Warn on Route Reset"
                            labelPlacement="start"
                            onChange={() => {
                              setIsRouteChecked(!isRouteChecked);
                              setIsRouteReset(true);
                            }}
                          />
                        </FormGroup>
                      </Grid>
                      <div style={{ paddingRight: "5px", textAlign: "right" }}>
                        <Button
                          color="primary"
                          variant="contained"
                          onClick={() => {
                            saveRouteReset();
                          }}
                          disabled={!isRouteReset}
                        >
                          <Save /> Save
                        </Button>
                      </div>
                    </CardContent>
                  </Card>
                </>
              </Grid>
            </>
          )}
        </Grid>
      ) : enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>
      ) : (
        <Alert severity="error">
          <AlertTitle>
            <Lock /> Access Error
          </AlertTitle>
          You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong>{" "}
          bottler on the application
          {settings.vs && !checkForRole(clientId, salesOrg, "vs_admin") ? <div> VendSmart</div> : <div></div>}
          {settings.vp && !checkForRole(clientId, salesOrg, "vp_admin") ? <div> VendPrime</div> : <div></div>}
        </Alert>
      )}
      <Dialog open={status} onClose={() => setStatus(false)}>
        <DialogTitle>System Configuration</DialogTitle>
        <DialogContent>
          <DialogContentText><h4> {statusMessage} </h4></DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setStatus(false);
            }}
            color="primary"
          >
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
